var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 8982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    d: "M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H8.9821C9.81053 2.5 10.4821 3.17157 10.4821 4V9.12329C10.4821 9.95172 9.81053 10.6233 8.9821 10.6233H4C3.17157 10.6233 2.5 9.95172 2.5 9.12329V4Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M2.5 15.1509C2.5 14.3225 3.17157 13.6509 4 13.6509H8.9821C9.81053 13.6509 10.4821 14.3225 10.4821 15.1509V20.2742C10.4821 21.1026 9.81053 21.7742 8.9821 21.7742H4C3.17157 21.7742 2.5 21.1026 2.5 20.2742V15.1509Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 79",
    d: "M13.478 4C13.478 3.17157 14.1496 2.5 14.978 2.5H19.9601C20.7886 2.5 21.4601 3.17157 21.4601 4V9.12329C21.4601 9.95172 20.7886 10.6233 19.9601 10.6233H14.978C14.1496 10.6233 13.478 9.95172 13.478 9.12329V4Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81",
    d: "M13.478 15.1509C13.478 14.3225 14.1496 13.6509 14.978 13.6509H19.9601C20.7886 13.6509 21.4601 14.3225 21.4601 15.1509V20.2742C21.4601 21.1026 20.7886 21.7742 19.9601 21.7742H14.978C14.1496 21.7742 13.478 21.1026 13.478 20.2742V15.1509Z",
    stroke: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCases);
export default __webpack_public_path__ + "static/media/Cases.ffd4f810be9a2ac035df5d4f96624f88.svg";
export { ForwardRef as ReactComponent };